import "./emailConfirmation.scss";
import { Link, useNavigate } from "react-router-dom";
import { HiOutlineBackspace } from "react-icons/hi";
import { IconContext } from "react-icons";
import { useForm } from "react-hook-form";
import React, { useEffect } from "react";

function EmailConfirmation() {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if the page was refreshed
    const wasRefreshed = localStorage.getItem("refreshed");
    if (wasRefreshed) {
      // Clear the flag in local storage
      localStorage.removeItem("refreshed");
      // Navigate to the desired route
      navigate("/user/creatuser");
    }

    // Set the flag in local storage to detect future refreshes
    localStorage.setItem("refreshed", "true");

    // Now, you can perform other actions when the component mounts

    // Clean up the local storage flag when the component unmounts
    return () => {
      localStorage.removeItem("refreshed");
    };
  }, [navigate]);

  const navigateToemailConfirmation = () => {
    navigate("/user/addressConfirmatioCreatUser");
  };
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => {
    navigateToemailConfirmation();
  };
  return (
    <div className="emailConfirmation">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="verification-numbers">
          <p>Enter the code sent to your email</p>
          <input
            autoFocus={true}
            type="number"
            placeholder=" _ _ _ _"
            id="verification-Digit"
            name="verificationDigit"
            {...register("verificationDigit", {
              required: true,
              validate: (value) => value == 1234,
            })}
            className={`${errors.verificationDigit && "invalid"}`}
          />
          {errors.verificationDigit &&
            errors.verificationDigit.type === "required" && (
              <span>This field is required</span>
            )}
          {errors.verificationDigit &&
            errors.verificationDigit.type === "validate" && (
              <span>The verification digits do not match</span>
            )}
        </div>

        <div className="buttons">
          <Link to="/">
            <button type="button">
              <IconContext.Provider value={{ className: "react-icons" }}>
                <HiOutlineBackspace />
              </IconContext.Provider>
              Previous
            </button>
          </Link>
          <input type="submit" value="Next" id="submit" className="Next" />
        </div>
      </form>
    </div>
  );
}

export default EmailConfirmation;
